<template>
    <div class="c-blog-banner">
        <div class="right-column">
            <div
                v-if=" $mq==='lg'|| $mq==='xlg' "
                :style="`marginTop: ${topMargin}px`"
            />
            <div
                v-if="$settings('content.blog_banner_image')"
                class="blog-banner-img"
            >
                <a :href="$settings('content.blog_banner_link')">
                    <img
                        v-if="$mq==='lg' || $mq==='xlg' "
                        :src="imgSrc($settings('content.blog_banner_image'))"
                        alt="banner"
                        class="blog-banner-img--lg"
                    >
                    <img
                        v-else
                        :src="imgSrc($settings('content.blog_banner_image'))"
                        alt="banner"
                        class="blog-banner-img--md"
                    >

                </a>
            </div>

            <div
                v-if="categoriesData"
                class="right-column__categories"
            >
                <h5 class="category-list-title">
                    {{ $t('blog.category_list') }}
                </h5>
                <ul class="category-list">
                    <router-link
                        v-for="category in categoriesData"
                        :key="category.id"
                        :to="{nam:'blog-category', params: {url_encode: category.url_encode}}"
                        class="category-list__item"
                    >
                        <img
                            v-if="category.image_header"
                            :src="imgSrc(category.image_header)"
                            :alt="category.title"
                            class="category-img"
                        >
                        <span class="category-title">{{ category.title }}</span>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script >

    export default {
        name: 'BlogSingleBanner',

        /**
         *
         * @inheritDoc
         */
        props: {
            categoriesData: {
                type: Array,
            },
            topMargin: {
                type: Number,
            },

        },

    };

</script>

<style lang="scss" src="./single-banner.scss"/>
